import { useState } from 'react';
import { InputCard } from '@components/cards';
import { RADIO } from '@components/cards/input-card/input-card.type';
import { EmptyBlock } from '@components/empty-block';
import { IconEmpty } from '@components/icons/icon-empty';
import { Loader } from '@components/loader';
import { useGetAdminUsers } from '@hooks/use-get-admin-users/use-get-admin-users';

import { ImpersonateRoleCards } from './impersonate-role-cards';
import { ImpersonateUserListContentProps } from './impersonate-user-modal.type';

export const ImpersonateUserListContent = ({
  email,
  setSelectedUser,
  companyId,
  onImpersonate,
}: ImpersonateUserListContentProps) => {
  const { data, isLoading } = useGetAdminUsers({ email }, { enabled: !!email, disableLoading: true });
  const [isChecked, setIsChecked] = useState(false);

  const handleClick = () => {
    setIsChecked((prev) => !prev);
    setSelectedUser(data);
  };

  const isSearching = !!email;

  return (
    <div className='mt-6'>
      {!isSearching && companyId && onImpersonate && (
        <ImpersonateRoleCards companyId={companyId} onImpersonate={onImpersonate} />
      )}
      {isLoading && <Loader />}
      {!data && isSearching && (
        <div data-testid='impersonate-modal--list-empty'>
          <EmptyBlock title={'No email, no party'}>
            <IconEmpty className='my-3 text-gray-500 dark:text-white' />
          </EmptyBlock>
        </div>
      )}
      {data && (
        <InputCard isChecked={isChecked} isDisabled={false} type={RADIO} handleClick={handleClick}>
          <div data-testid='impersonate-modal--list-content'>
            <p className='text-base text-left font-bold text-primary'>{data.fullName}</p>
            <p className='text-sm text-left text-gray-700 dark:text-white'>{data.email}</p>
          </div>
        </InputCard>
      )}
    </div>
  );
};
